import { createSlice } from '@reduxjs/toolkit';
import { loginUser } from './loginThunk'; 

const initialState = {
  user: null,                                           // Stores the user data when logged in
  isAuthenticated: false,                               // Stores whether the user is authenticated or not
  loading: false,                                       // Tracks if the login API call is in progress
  error: null,                                          // Tracks any error message if the login fails
};

// Create the slice with reducers and extra reducers for async actions
const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
      sessionStorage.removeItem('user');
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle pending state when login is requested
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // Handle fulfilled state when login is successful
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;            
        state.isAuthenticated = true;          
        sessionStorage.setItem('user',JSON.stringify(action.payload));   
      })
      
      // Handle rejected state when login fails
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.error = action.payload || action.error.message;          
      });
  },
});

export const { logout } = loginSlice.actions;                      
export default loginSlice.reducer;                                      